// Shared date helpers for ScoreChart and StrategyChart.

export const parseDateMs = (dateStr) => new Date(`${dateStr}T00:00:00Z`).getTime();

// history entries may arrive in either order depending on what the backend
// ultimately ships (the spec's history-file example is newest-first, but the
// strategy-simulation snippet iterates oldest-first) — sort defensively by
// `date` here rather than trusting array order, so both charts always read
// left-to-right oldest-to-newest regardless.
export const toSortedPoints = (history, numericField) =>
  (history || [])
    .filter((d) => d && typeof d.date === 'string' && typeof d[numericField] === 'number')
    .map((d) => ({ ...d, ts: parseDateMs(d.date) }))
    .sort((a, b) => a.ts - b.ts);

// Collapses a sorted (oldest→newest) list of points into contiguous x-axis
// time bands, one per run of consecutive entries sharing the same `zone`
// ('green'/'yellow'/'red'). Used by ScoreChart's S&P 500 view to color-code
// the chart BACKGROUND by our zone over time via `xAxis.plotBands`: rather
// than one band per day (thousands of near-invisible slivers), consecutive
// same-zone days merge into a single {from, to, color} band.
//
// Each band extends to the NEXT point's timestamp (not just the last day of
// its own run), so adjacent bands butt up against each other and the
// background reads as one continuous colored strip with no white gaps between
// runs. The final band extends to its own last day (there's no next point to
// bridge to).
//
// `zoneColors` maps a zone name to its (faint) band color; entries whose zone
// "N calendar months before `date`", clamped to the target month's actual
// length. `date.setUTCMonth(date.getUTCMonth() - months)` alone overflows
// whenever `date`'s day-of-month doesn't exist in the target month (e.g. Aug
// 31 minus 6 months naively rolls past Feb 28/29 into March) — clamping the
// day first avoids that rollover.
export const monthsBack = (date, months) => {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const targetMonthIndex = month - months;
  const daysInTargetMonth = new Date(Date.UTC(year, targetMonthIndex + 1, 0)).getUTCDate();
  return new Date(Date.UTC(year, targetMonthIndex, Math.min(day, daysInTargetMonth)));
};
